import MerchantBranchesApi from '@/api/merchant/branches'

const state = {
  merchantBranches: [],
  error: null,
  fetchingMerchantBranches: false,
}

const mutations = {
  // Define your mutations here
  SET_FETCHING(state, { name, value }) {
    state[name] = value
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  ADD_MERCHANT_BRANCHES(state, { merchantBranches }) {
    state.merchantBranches = merchantBranches
  },
}

const getters = {}

const actions = {
  async fetchMerchantBranches({ commit }, merchantIds) {
    try {
      commit('SET_FETCHING', { name: 'fetchingMerchantBranches', value: true })

      if (
        !merchantIds ||
        !Array.isArray(merchantIds) ||
        merchantIds.length === 0
      ) {
        return
      }
      const params = merchantIds.map((id) => `merchantIds[]=${id}`).join('&')

      const response = await MerchantBranchesApi.fetchAllBranches(params)

      commit('SET_FETCHING', { name: 'fetchingMerchantBranches', value: false })
      commit('ADD_MERCHANT_BRANCHES', { merchantBranches: response.data.data })
    } catch (error) {
      commit('SET_ERROR', error)
      commit('SET_FETCHING', { name: 'fetchingMerchantBranches', value: false })
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
